module.exports = __webpack_public_path__ + "img/Heather_Lind.fc6d437f.jpg";